import merge from 'lodash.merge'

import conditionFr from './condition/fr.json'
import { filtersFr } from './filters'
import globalFr from './fr.json'
import userFr from './user/fr.json'

export const commonsFr = merge(
  {},
  globalFr,
  conditionFr,
  filtersFr,
  userFr,
)
